import { apiClient } from './ApiClient';
import { buildQueryString } from '../utils/QueryStringBuilder';

export type Tag = {
  tagId: string;
  tagName: string;
};

type TagResponse = {
  results: Tag[];
};

type GetTagsQueryParams = {
  limit?: number;
  next?: string;
};

export const getTags = async (limit?: number): Promise<TagResponse> => {
  const queryString = buildQueryString<GetTagsQueryParams>({ limit });
  const response = await apiClient.getClient().get(`tags${queryString}`);
  return response.data;
};

export const getTagByName = async (name: string): Promise<Tag> => {
  const response = await apiClient.getClient().get(`tags?name=${name}`);
  return response.data;
};

export const createTag = async (name: string): Promise<Tag> => {
  const response = await apiClient.getClient().post(`tags`, { name });
  return response.data;
};

export const deleteTag = async (id: string): Promise<string> => {
  const response = await apiClient.getClient().delete(`tags/${id}`);
  return response.data;
};

export const disassociateTag = async (params: {
  serialNumber: string;
  tagId: string;
}): Promise<string> => {
  const response = await apiClient
    .getClient()
    .post(`/tags/${params.tagId}/device/${params.serialNumber}/dissociate`);
  return response.data;
};
export const associateTag = async (params: {
  serialNumber: string;
  tagId: string;
  tagName: string;
}): Promise<string> => {
  const response = await apiClient
    .getClient()
    .post(`/tags/${params.tagId}/device/${params.serialNumber}/associate`);
  return response.data;
};
